import axios from 'axios';

export default {
  list: (params = {}, config = {}) => axios.get('financial-accounts', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('financial-accounts', payload, config),
  show: (financialAccountId, config = {}) => axios.get(`financial-accounts/${financialAccountId}`, config),
  update: (financialAccountId, payload = {}, config = {}) => axios.put(`financial-accounts/${financialAccountId}`, payload, config),
  delete: (financialAccountId, config = {}) => axios.delete(`financial-accounts/${financialAccountId}`, config),
  movements: (financialAccountId, params = {}, config = {}) => axios.get(`financial-accounts/${financialAccountId}/movements`, { params, ...config }),
  selectors: (params = {}, config = {}) => axios.get('financial-accounts/selectors', { params, ...config }),
};
